export default __webpack_public_path__ + "static/media/default.dc0dfc42.png";